/** Parse REACT_APP_* boolean flags (true/false, 1/0, yes/no, on/off). */
function parseEnvFlag(value, defaultEnabled) {
  if (value === undefined || value === null || String(value).trim() === "") {
    return defaultEnabled;
  }
  const v = String(value).trim().toLowerCase();
  if (["1", "true", "yes", "on"].includes(v)) return true;
  if (["0", "false", "no", "off"].includes(v)) return false;
  return defaultEnabled;
}

/**
 * Whether the moving-supplies store appears on the main quote form
 * (homepage, /quote, SEO QuoteEmbed). Default: disabled.
 */
export function isMainQuoteExtrasStoreEnabled() {
  return parseEnvFlag(process.env.REACT_APP_QUOTE_EXTRAS_STORE_ENABLED, false);
}

/**
 * Merchant iframe widget and QuoteWidget variant="widget".
 * Default: disabled - set REACT_APP_WIDGET_QUOTE_EXTRAS_STORE_ENABLED=true to show.
 */
export function isWidgetQuoteExtrasStoreEnabled() {
  return parseEnvFlag(process.env.REACT_APP_WIDGET_QUOTE_EXTRAS_STORE_ENABLED, false);
}

/**
 * @param {{ widget?: boolean, explicit?: boolean }} options
 *   explicit - prop override from parent (e.g. QuoteEmbed)
 */
export function resolveQuoteExtrasStoreEnabled({ widget = false, explicit } = {}) {
  if (explicit !== undefined && explicit !== null) return !!explicit;
  return widget ? isWidgetQuoteExtrasStoreEnabled() : isMainQuoteExtrasStoreEnabled();
}
